<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <!--診間診號查詢-->
    <v-flex row wrap xs12 sm12 md12 lg12 ml-2 mr-2 :style="{marginBottom:$vuetify.breakpoint.smAndDown?'56px':'auto'}">

      <v-container>
        <v-row>
          <v-col cols="12" class="text-center">
            <v-progress-linear v-show="isLoading" :indeterminate="isLoading"></v-progress-linear>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="5" class="text-center">
            <v-radio-group v-model="apnRadio" row hide-details @change="clickApn">
              <v-radio value='1'>
                <template v-slot:label>
                  <div class="clinicNoTitle">上午</div>
                </template>
              </v-radio>
              <v-radio value='2'>
                <template v-slot:label>
                  <div class="clinicNoTitle">下午</div>
                </template>
              </v-radio>
              <v-radio value='3'>
                <template v-slot:label>
                  <div class="clinicNoTitle">晚上</div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-col>

          <v-col cols="12" sm="12" md="7" :class="[$vuetify.breakpoint.smAndDown?'text-center':'text-left', 'clinicNoTitle']">
            <v-row>
              <v-col cols="12" sm="9" md="9">
                [{{zoneName}}] <br>
                {{apnTitle}} {{this.$UtilityJs.AD2ROC_DateTime(new Date().toISOString(),'date')}}目前看診號
              </v-col>
              <v-col cols="12" sm="3" md="3" class="text-right">
                <v-btn text light @click.native="axios_getClinicNoList('0')">
                  <v-icon>mdi-reload</v-icon>重新整理
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="9">
            <table class="clinicTableOutline elevation-1" style="width: 100%">
              <thead class="clinicNoThead">
              <tr>
                <th class="clinicNoTh">科別名稱</th>
                <th class="clinicNoTh">診間</th>
                <th class="clinicNoTh">醫師</th>
                <th class="clinicNoTh">診號</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in clinicNoList" :key="index">
                <td :class="['text-center', index % 2 == 0 ? 'clinicNoTdOdd' : 'clinicNoTd']">
                  <div class="clinicNoTdDiv">
                    {{ item.divName }}
                  </div>
                </td>
                <td :class="['text-center', index % 2 == 0 ? 'clinicNoTdOdd' : 'clinicNoTd']">
                  <div class="clinicNoTdDiv">
                    {{ item.clinicName }}
                  </div>
                </td>
                <td :class="['text-center', index % 2 == 0 ? 'clinicNoTdOdd' : 'clinicNoTd']">
                  <div class="clinicNoTdDiv">
                    {{ item.doctorName }}
                  </div>
                </td>
                <td :class="['text-center', index % 2 == 0 ? 'clinicNoTdOdd' : 'clinicNoTd']">
                  <div class="clinicNoTdDivLast">
                    {{ item.nowViewNo }}
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
            <div class="text-right mt-1">
              <span>最近更新時間: {{updateTime}}</span>
            </div>
          </v-col>

          <v-col cols="12" sm="12" md="3">
            <p style="font-size: 1.2rem" v-html="regNote"></p>
          </v-col>
        </v-row>
      </v-container>

        <!-- <v-flex class="xs12 sm12 md3 lg2 pl-1 mt-1">
        </v-flex> -->

        <!-- 我是 snackbar -->
        <v-snackbar
                :timeout="snTimeout"
                v-model="snStatus">
            {{snText}}
        </v-snackbar>

    </v-flex>
</template>

<script>
    export default {
        name: "ClinicNoSearch",
        created(){
           this.axios_getClinicNoList('0');
           this.axios_getZoneName();
           this.axios_getRegNote();
        },
        data() {
            return {
                zoneName:'',
                apnRadio:0,
                clinicNoList: [],
                isLoading:false,
                snTimeout:4000,
                snStatus:false,
                snText:'',
                updateTime:'',
                apnTitle:'',
                timers:null,
                regNote:"",
            }
        },
        destroyed(){
            clearTimeout(this.timers); //要記得先清除實例 再call API
        },
        beforeDestroy(){
            clearTimeout(this.timers); //要記得先清除實例 再call API
        },
        watch: {
            '$route.params': function () {
                this.axios_getClinicNoList('0');
                this.axios_getZoneName();
            },
        },
        methods:{
            clickApn(val){
                this.axios_getClinicNoList(val);
            },
            transApn(apn){
                this.apnTitle = '';
                switch (apn){
                    case 1:
                        this.apnTitle = '上午'
                        break;
                    case 2:
                        this.apnTitle = '下午'
                        break;
                    case 3:
                        this.apnTitle = '晚上'
                        break;
                    default:
                }
            },
            axios_getClinicNoList (apn){ //取得目前診間診號
                clearTimeout(this.timers); //要記得先清除實例 再call API
                this.clinicNoList = [];
                this.isLoading = true;
                let url = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                url = this.$store.state.AppSetting.backSrvUrl + "clinicparam/byzoneapn/"+zone+"/"+apn;

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0&&response.data.status=="INFO"){
                        this.clinicNoList = response.data.resultSet
                        this.isLoading = false;
                        this.updateTime = this.$UtilityJs.AD2ROC_DateTime(new Date().toISOString(),'all');
                        this.transApn(this.clinicNoList[0].apn);
                        this.apnRadio = this.clinicNoList[0].apn.toString();
                    }else{
                        this.clinicNoList = [];
                        this.isLoading = false;
                    }

                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.clinicNoList = [];
                        this.isLoading = false;
                    } catch(err) {
                        this.clinicNoList = [];
                        this.isLoading = false;
                    }
                });
                let that = this;
                this.timers =    setTimeout(function(){ that.axios_getClinicNoList(apn); }, 60000);

            },

            axios_getZoneName (){  //查詢院區名稱
                this.zoneName = '';
                let url = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                url = this.$store.state.AppSetting.backSrvUrl + "zoneset/datasearch/primarykeys/"+zone;
                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.zoneName = response.data.resultSet[0].zoneName;
                    }else{
                        this.zoneName ='';
                    }
                }).catch(error =>  {
                    this.zoneName = '';
                    try {
                        console.log(error.response.data.status);

                    } catch(err) {
                        console.log(err.toString())
                    }
                });
            },

            axios_getRegNote (){ //看診進度說明
                let url = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                url = this.$store.state.AppSetting.backSrvUrl + "regnote/datasearch/primarykeys/"+zone+"/VIEWNO/ALL";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        for(let i in response.data.resultSet){
                            if(response.data.resultSet[i].regNote!==undefined&&response.data.resultSet[i].regNote!==''){
                                this.regNote+=response.data.resultSet[i].regNote+"<br/>"
                            }
                        }
                    }


                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                    } catch(err) {
                        console.log(err.response.data.status);
                    }
                });
            },

        }
    }
</script>

<style scoped>







</style>